import { request } from "./http";

function withQuery(path, params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    qs.set(key, String(value));
  });
  const query = qs.toString();
  return query ? `${path}?${query}` : path;
}

export const psychologistVerificationApi = {
  queue({ status = "PENDING", q = "", page = 0, size = 20 } = {}) {
    return request(
      withQuery("/api/admin/psychologists/verification/queue", {
        status,
        q,
        page: Number(page) || 0,
        size: Number(size) || 20,
      })
    );
  },

  stats() {
    return request("/api/admin/psychologists/verification/stats");
  },

  getOne(userId) {
    const id = encodeURIComponent(String(userId));
    const nonce = Date.now();
    return request(`/api/admin/psychologists/verification/${id}?_=${nonce}`, {
      cache: "no-store",
    });
  },

  approve(userId, note = "") {
    return request(`/api/admin/psychologists/verification/${encodeURIComponent(String(userId))}/approve`, {
      method: "POST",
      json: { note: note || "" },
    });
  },

  reject(userId, note = "") {
    return request(`/api/admin/psychologists/verification/${encodeURIComponent(String(userId))}/reject`, {
      method: "POST",
      json: { note: note || "" },
    });
  },
};
